import type { z } from "zod/v4";
import { type broadcastNotificationSchema, notificationSchema } from "../schemas/notification";
import type { ListParams } from "./games";
import { fetchApi, fetchVoid, paginatedSchema, toSearchParams } from "./internal";

export const notifications = {
	list: (params: ListParams = {}) => {
		const qs = toSearchParams(params);
		return fetchApi(
			`/admin/notifications${qs ? `?${qs}` : ""}`,
			paginatedSchema(notificationSchema),
		);
	},
	broadcast: (data: z.infer<typeof broadcastNotificationSchema>) =>
		fetchVoid("/admin/notifications", {
			method: "POST",
			body: JSON.stringify(data),
		}),
};
